<div class="ab-list-item-inner flex w-100 activity-type--response">
    <span class="ab-list-item__icon"
          *ngIf="item.itemType === 'TaggableLogbook'">
        <i class="icon fal fa-comment-plus"></i>
        <i class="icon fal fa-share-alt"
           *ngIf="item.name === 'create_entity_connection_tags'"></i>
        <i class="icon fal fa-calendar-star"
          *ngIf="item.name === 'create_calendar_event_response_tags'"></i>
    </span>

    <div class="ab-list-item__content">
        <div class="summary">
            <span class="actor">{{item?.user?.name}}</span> added
            a response to
            <app-activity-target-link [target]="item.target"
                                      *ngIf="item?.target?.__typename === 'Entity'">
                {{item.target | fullName}}
            </app-activity-target-link>
            <ng-container *ngIf="item?.target?.__typename === 'EntityConnection'">
                connection:
                <app-activity-target-link [target]="item.target.entity1">
                    {{item.target.entity1 | fullName}}
                </app-activity-target-link> &
                <app-activity-target-link [target]="item.target.entity2">
                    {{item.target.entity2 | fullName}}
                </app-activity-target-link>
            </ng-container>
            <ng-container *ngIf="item?.target?.__typename === 'CalendarEventResponse'">
              <a routerLink="/events/view"
                [queryParams]="{ campaignId: item.target.entity.campaignContextId, eventId: item.target.calendarEvent.id }"
                class="affected-user user-profile-link">
                {{ item.target.calendarEvent.name }} &mdash;
                <small>
                  {{ item.target.calendarEvent.startDate | date:"M/d/yy 'at' h:mma" }}
                </small>
              </a> for
              <app-activity-target-link [target]="item.target.entity">
                {{item.target.entity | fullName}}
              </app-activity-target-link>
            </ng-container>
        </div>
        <div class="details">
            <span class="tag">{{categoryName}}</span>:
            <strong class="response">{{responseName}}</strong>
            <p *ngIf="payload.notes && payload.notes[0]">
                <span *ngIf="payload.tag.tagType === 'Date'">{{payload.notes[0]?.text | date:short}} </span>
                <span *ngIf="payload.tag.tagType === 'Number'">{{payload.notes[0]?.text | number}} </span>
                <span *ngIf="payload.tag.tagType === 'Notes'"
                      [innerHtml]="payload.notes[0]?.text | escapedHtml | autolinker"></span>
            </p>
            <app-shift-response-view *ngIf="payload.tag.tagType ==='Shift' && payload?.shift"
                                     [shift]="payload.shift"
                                     class="d-block mt-0075"></app-shift-response-view>
        </div>
    </div>
    <app-activity-event-timestamp [item]="item"
                                  class="ab-list-item__timestamp">
    </app-activity-event-timestamp>
</div>
